import React from 'react'
import { IoArrowBackCircleSharp } from "react-icons/io5";
const BackButton = ({ onClick }) => {
    return (
        <>
            <IoArrowBackCircleSharp className='cursor-pointer' onClick={() => {
                onClick()
            }} size={25} />
        </>
    )
}

export default BackButton